import * as yup from 'yup';


const urlRegExp =  /^https:\/\/(.*)/;

export const validationSchema = yup.object({
  general: yup.object({
    'store_info/premium_plus_cta/is_premium_plus_cta_enable': yup
      .string()
  }),
  first: yup.object().shape({
    'store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_title': yup
      .string()
      .ensure()
      .test(
        'first-title',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_image': yup
      .string()
      .ensure()
      .test(
        'first_image',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      )
      .test(
        'first-image',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_blog/is_premium_plus_blog_enabled'] == 1;
          const isUrl = val?.match(urlRegExp);
          return isBlockEnable ? Boolean(isUrl) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_redirect': yup
      .string()
      .ensure()
      .test(
        'first-link',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          const isUrl = val?.match(urlRegExp);
          return (isBlockEnable && !!val) ? Boolean(isUrl) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_first_item/premium_plus_cta_first_item_category': yup
      .string()
      .ensure()
      .test(
        'first_category',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      )
  }),
  second: yup.object().shape({
    'store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_title': yup
      .string()
      .ensure()
      .test(
        'second',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_image': yup
      .string()
      .ensure()
      .test(
        'second_image',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      )
      .test(
        'second-image',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_blog/is_premium_plus_blog_enabled'] == 1;
          const isUrl = val?.match(urlRegExp);
          return isBlockEnable ? Boolean(isUrl) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_category': yup
      .string()
      .ensure()
      .test(
        'second_category',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_second_item/premium_plus_cta_second_item_redirect': yup
      .string()
      .ensure()
      .test(
        'second-link',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          const isUrl = val?.match(urlRegExp);
          return (isBlockEnable && !!val) ? Boolean(isUrl) : true;
        }
      )
  }),
  third: yup.object().shape({
    'store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_title': yup
      .string()
      .ensure()
      .test(
        'third',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_image': yup
      .string()
      .ensure()
      .test(
        'third_image',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      )
      .test(
        'third-image',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_blog/is_premium_plus_blog_enabled'] == 1;
          const isUrl = val?.match(urlRegExp);
          return isBlockEnable ? Boolean(isUrl) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_category': yup
      .string()
      .ensure()
      .test(
        'third_category',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_third_item/premium_plus_cta_third_item_redirect': yup
      .string()
      .ensure()
      .test(
        'third-link',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          const isUrl = val?.match(urlRegExp);
          return (isBlockEnable && !!val) ? Boolean(isUrl) : true;
        }
      ),
  }),
  fourth: yup.object().shape({
    'store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_title': yup
      .string()
      .ensure()
      .test(
        'fourth',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_image': yup
      .string()
      .ensure()
      .test(
        'fourth_image',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      )
      .test(
        'fourth-image',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_blog/is_premium_plus_blog_enabled'] == 1;
          const isUrl = val?.match(urlRegExp);
          return isBlockEnable ? Boolean(isUrl) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_category': yup
      .string()
      .ensure()
      .test(
        'fourth_category',
        'Field is required',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          return isBlockEnable ? Boolean(val) : true;
        }
      ),
    'store_info/premium_plus_cta/premium_plus_cta_fourth_item/premium_plus_cta_fourth_item_redirect': yup
      .string()
      .ensure()
      .test(
        'fourth-link',
        'Link must start with https://',
        (val, values) => {
          const isBlockEnable = values?.from[1].value.general['store_info/premium_plus_cta/is_premium_plus_cta_enable'] == 1;
          const isUrl = val?.match(urlRegExp);
          return (isBlockEnable && !!val) ? Boolean(isUrl) : true;
        }
      ),
  })
});
